import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  Box,
  CardContent,
  CardHeader,
  LinearProgress,
  Link,
} from "@mui/material";
import { FC } from "react";
import RecipeContentList from "./RecipeContentList";
import { useGetRecipe } from "../api-hooks";

type RecipeProps = {
  readonly url: string;
};

const Recipe: FC<RecipeProps> = ({ url }) => {
  const { data, isSuccess, isLoading } = useGetRecipe(url);

  if (isLoading) {
    return <LinearProgress />;
  }

  return isSuccess ? (
    <>
      <CardHeader
        title={data.title}
        subheader={
          <Box
            sx={{
              display: "flex",
              alignItems: "left",
              flexDirection: "column",
            }}
          >
            <Link href={url} underline='hover' target='_blank' rel='noreferrer'>
              <OpenInNewIcon />
              {url}
            </Link>
            <Box flexDirection={"column"}>
              <Box>Servings: {data.servings || "not specified"}</Box>
              <Box>Total Time: {data.cookingTime || "not specified"}</Box>
              <Box>Rating: {data.rating}</Box>
            </Box>
          </Box>
        }
      />
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 3,
            alignContent: 'flex-start'
          }}
        >
          <Box sx={{ flex: 1 }}>
            <RecipeContentList stages={data.ingredients} title='Ingredients' />
          </Box>
          <Box sx={{ flex: 1 }}>
            <RecipeContentList stages={data.directions} title='Directions' />
          </Box>
        </Box>
      </CardContent>
    </>
  ) : null;
};

export default Recipe;
